import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';
import {
    SERVICES_AND_STAFFING,
    RELIABLE_ONSALES,
    INTEGRATIONS_C,
    PAYOUTS_C,
    WHITE_LABELING_A,
    WHITE_LABELING_B,
    DETAILED_ANALYTICS_B,
    DISTRIBUTION_A,
    DISTRIBUTION_B,
    CHECKOUT_WIDGET_C,
    VIP_EXPERIENCES_B,
    INCLUDE_PROFESSIONAL,
    RENT_EQUIPMENT,
    ONSITE_SUPPORT,
    PHONE_24_7_SUPPORT,
    TEAM_PERMISSIONS_A,
    TEAM_PERMISSIONS_B,
    RFID_TECHNOLOGY,
    TRAINING_AND_SUPPORT_A,
    TRAINING_AND_SUPPORT_B,
    CUSTOMER_SUCCESS_MANGER_SUPPORT,
} from '../../constants/features';
import {
    NATIONAL_SAWDUST,
    GENERAL_ASSEMBLY,
    GILROY_GARLIC_FESTIVAL,
} from '../../constants/testimonials';
import {
    DEFAULT_PACKAGES,
    CONTACT_US_TEXT,
    CUSTOM_PRICING,
    PACKAGE_THREE,
} from '../../constants/main';
import {
    STYLE_FILL,
    STYLE_NEUTRAL,
} from 'eventbrite_design_system/button/constants';

import AssortmentsPremiumComplexIllustrationSvg from 'eventbrite_design_system/iconography/icons/AssortmentsPremiumComplexIllustration';

export default {
    mainHeader: {
        tabs: DEFAULT_PACKAGES,
        currentIndex: 2,
        imagePath: `${PACKAGE_THREE}/premium-hero-graphic`,
        bgImgHeight: 425,
        heading: lazyGettext('Premium'),
        secondaryHeading: lazyGettext(
            'One trusted partner for all the moving pieces',
        ),
        price: CUSTOM_PRICING,
        priceDescription: lazyGettext('Minimum threshold applies'),
        primaryCTA: CONTACT_US_TEXT,
        secondaryCTA: CONTACT_US_TEXT,
        CTAStyle: STYLE_FILL,
        dataAutomation: 'package-three-main-header',
    },
    featureListOne: {
        heading: lazyGettext('Partnership to scale your business'),
        secondaryHeading: lazyGettext(
            "Eventbrite is not just a technology platform — we're a strategic partner with the battle-tested experience to help you accelerate your growth and operate at scale.",
        ),
        features: [
            TRAINING_AND_SUPPORT_A,
            SERVICES_AND_STAFFING,
            RELIABLE_ONSALES,
        ],
        imagePaths: [
            `${PACKAGE_THREE}/training`,
            `${PACKAGE_THREE}/staff`,
            `${PACKAGE_THREE}/crowd`,
        ],
    },
    featureListTwo: {
        heading: lazyGettext('Streamline your operations'),
        features: [TEAM_PERMISSIONS_A, INTEGRATIONS_C, PAYOUTS_C],
        imagePath: `${PACKAGE_THREE}/brand--simplify`,
        secondaryCTA: CONTACT_US_TEXT,
    },
    featureListThree: {
        heading: lazyGettext('Grow your sales and amplify your brand'),
        features: [WHITE_LABELING_A, DISTRIBUTION_A, DETAILED_ANALYTICS_B],
        imagePath: `${PACKAGE_THREE}/stella-dot`,
        secondaryCTA: CONTACT_US_TEXT,
    },
    featureListFour: {
        heading: lazyGettext("'Wow' your most passionate advocates"),
        features: [DISTRIBUTION_B, CHECKOUT_WIDGET_C, VIP_EXPERIENCES_B],
    },
    featureImage: {
        imagePath: `${PACKAGE_THREE}/RFID`,
    },
    testimonials: {
        heading: lazyGettext('Rely on a proven partner'),
        testimonials: [
            NATIONAL_SAWDUST,
            GENERAL_ASSEMBLY,
            GILROY_GARLIC_FESTIVAL,
        ],
    },
    featuresExpansion: {
        heading: lazyGettext('Premium features and services'),
        features: [
            INCLUDE_PROFESSIONAL,
            RENT_EQUIPMENT,
            ONSITE_SUPPORT,
            PHONE_24_7_SUPPORT,
            TEAM_PERMISSIONS_B,
            RFID_TECHNOLOGY,
            WHITE_LABELING_B,
            TRAINING_AND_SUPPORT_B,
            CUSTOMER_SUCCESS_MANGER_SUPPORT,
        ],
    },
    middleBanner: {
        illustration: <AssortmentsPremiumComplexIllustrationSvg />,
        heading: lazyGettext("Have any questions? We're here to help."),
        CTA: CONTACT_US_TEXT,
        CTAStyle: STYLE_NEUTRAL,
    },
    bottomBanner: {
        illustration: <AssortmentsPremiumComplexIllustrationSvg />,
        heading: lazyGettext('Eventbrite Premium'),
        secondaryHeading: lazyGettext('Transform Your Business'),
        CTA: CONTACT_US_TEXT,
        CTAStyle: STYLE_NEUTRAL,
    },
};
